import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const SCREENSHOT_URL = `${api.baseRootUrl}/uploads/screenshots/`;
const IMAGE_URL = `${api.baseRootUrl}/uploads/modules/`;
// const MODULE_MANAGE_URL = '/modules/';

const ModuleService = new ModelService(apiRoutes.modules, '/modules', 'modules');

ModuleService.TYPE_BLOG = 'blog';
ModuleService.TYPE_KB = 'kb';
ModuleService.TYPE_TICKETS = 'tickets';
ModuleService.TYPE_INTERCOM = 'intercom';
ModuleService.TYPE_LINK = 'link';
ModuleService.TYPE_DOCUMENTS = 'docs';
ModuleService.TYPE_GOOGLE = 'google';
ModuleService.TYPE_GITHUB = 'github'
ModuleService.TYPE_LINKEDIN = 'linkedin';
ModuleService.TYPE_TWITTER = 'tw';
ModuleService.TYPE_FACEBOOK = 'fb';
ModuleService.TYPE_PAGE = 'page';
ModuleService.TYPE_FEEDBACK = 'feedback';
ModuleService.TYPE_MESSAGE = 'message';
ModuleService.TYPE_ZAPIER = 'zapier';
ModuleService.TYPE_EMOJI_GIF = 'emoji-gif';
ModuleService.TYPE_YOUTUBE = 'youtube';
ModuleService.TYPE_VIMEO = 'vimeo';
ModuleService.TYPE_JS = 'js';
ModuleService.TYPE_CUSTOMERLY = 'customerly';
ModuleService.TYPE_ACTIVE_CHAT = 'activechat';
ModuleService.TYPE_GALLERY = 'gallery';
ModuleService.TYPE_CALENDLY_PAGE = 'calendly-page';
ModuleService.TYPE_STRIPE_INVOICES = 'stripe-invoices';

ModuleService.getCategories = () => api.catchError(async () => {
  const { data } = await api.get(apiRoutes.moduleCategories);
  return data;
});

ModuleService.get = type => api.catchError(async () => {
  const { data } = await api.get(`${apiRoutes.modules}/${type}`);
  return data;
});

ModuleService.getSrc = (module) => {
  const { image, default_image, icon, custom_icon } = module;
  if (custom_icon > 0) return ModuleService.getFileUrl(custom_icon);
  const iconSrc = icon ? '' : '/img/emo5.svg';
  const defaultSrc = default_image ? `/img/${default_image}` : iconSrc;
  const src = image ? ModuleService.getImagePath(image) : defaultSrc;
  return src;
};

ModuleService.getSocial = () => api.catchError(async () => {
  const { data } = await api.get(`${apiRoutes.modules}-social`);
  return data;
});

ModuleService.validRequirementsModules = type => api.catchError(async () => {
  const { data } = await api.get(`${apiRoutes.modules}/${type}`);
  return data;
});

ModuleService.getScreenshotPath = imageName => SCREENSHOT_URL + imageName;
ModuleService.getImagePath = imageName => IMAGE_URL + imageName;
ModuleService.getModuleLink = type => `${ModuleService.baseRoute}/${type}`;

export default ModuleService;



// WEBPACK FOOTER //
// ./src/services/module.service.js